export const MAX_MINOR = 9223372036854775807n;
export function minor(value: string | bigint): bigint {
  if (typeof value === "string" && !/^-?(0|[1-9]\d*)$/.test(value))
    throw new Error("invalid_money");
  const parsed = BigInt(value);
  if (parsed > MAX_MINOR || parsed < -MAX_MINOR)
    throw new Error("money_overflow");
  return parsed;
}
export function parseBRL(value: string): bigint {
  const clean = value.trim().replace(/^R\$\s*/, "");
  if (!/^-?(?:\d+|[1-9]\d{0,2}(?:\.\d{3})+)(?:,\d{1,2})?$/.test(clean))
    throw new Error("invalid_money_format");
  const [whole, fraction = ""] = clean.replaceAll(".", "").split(",");
  const sign = whole!.startsWith("-") ? -1n : 1n;
  return minor(
    sign *
      (BigInt(whole!.replace("-", "")) * 100n +
        BigInt(fraction.padEnd(2, "0"))),
  );
}
export function formatBRL(value: string | bigint | null): string {
  if (value === null) return "Não informado";
  const amount = minor(value);
  const abs = amount < 0n ? -amount : amount;
  const integer = (abs / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${amount < 0n ? "−" : ""}R$ ${integer},${(abs % 100n).toString().padStart(2, "0")}`;
}
export function sumMoney(values: readonly bigint[]): bigint {
  return minor(values.reduce((sum, value) => sum + minor(value), 0n));
}
export function splitInstallments(total: bigint, count: number): bigint[] {
  minor(total);
  if (total < 0n || !Number.isInteger(count) || count < 1 || count > 600)
    throw new Error("invalid_installments");
  const quotient = total / BigInt(count),
    remainder = total % BigInt(count);
  return Array.from(
    { length: count },
    (_, index) => quotient + (BigInt(index) < remainder ? 1n : 0n),
  );
}
export function projectedReference(actual: bigint, reference: bigint | null) {
  const remaining =
    reference !== null && reference > actual ? reference - actual : 0n;
  return { actual, remaining, projected: actual + remaining };
}
